import i18next from 'i18next'

const generatePdfContentNotebook = ({ t, correlation, withOffer }) => {
  const pageWidth = 596
  const pageHeight = 842

  const contentWidth = pageWidth / 3
  const contentHeight = pageHeight / 3

  const createContent = coupon => ({
    stack: [
      {
        text: `${coupon.site.name.length > 30 ? coupon.site.name.substring(0, 28) + '...' : coupon.site.name}`,
        style: 'header'
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: contentWidth,
            y2: 0,
            lineWidth: 0.8,
            lineColor: '#C7C7C7'
          }
        ]
      },
      { text: t('coupons.actions.print_code.pdf.connexion_code'), margin: [25, 8, 0, 0], fontSize: 8 },
      {
        table: {
          widths: ['85%'],
          body: [
            [
              {
                text: `${coupon.code}`,
                style: 'fieldValue',
                fontSize: 10,
                alignment: 'center'
              }
            ]
          ]
        },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => '#3B82F6',
          vLineColor: (i, node) => (i === node.table.widths.length - 1 ? '#3B82F6' : '#3B82F6'),
          paddingTop: () => 8,
          paddingBottom: () => 8
        },
        width: contentWidth,
        height: contentHeight,
        margin: [25, 4, 0, 10]
      },
      ...(withOffer ? [
        { text: t('coupons.actions.print_code.pdf.internet_access'), margin: [25, 0, 0, 0], fontSize: 8 },
        {
          table: {
            widths: ['85%'],
            body: [
              [
                {
                  text: `${
                    coupon.offer?.name
                      ? coupon.offer.name
                      : `${t('coupons.table.validity_col.from')}${new Date(coupon.starts_at).toLocaleDateString(
                        i18next.language
                      )}${t('coupons.table.validity_col.to')}${new Date(coupon.ends_at).toLocaleDateString(
                        i18next.language
                      )} - ${coupon.number_of_devices} ${t('coupons.actions.print_code.pdf.devices')}`
                  }`,
                  fontSize: coupon?.offer?.name.length > 50 ? 8 : 10,
                  style: 'fieldValue',
                  alignment: 'center'
                }
              ]
            ]
          },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => '#3B82F6',
            vLineColor: (i, node) => (i === node.table.widths.length - 1 ? '#3B82F6' : '#3B82F6'),
            paddingTop: () => 8,
            paddingBottom: () => 8
          },
          width: contentWidth,
          height: contentHeight,
          margin: [25, 4, 0, 10]
        },
      ]: []),
      {
        ol: [
          { text: t('coupons.actions.print_code.pdf.helper.other'), margin: [0, 0, 0, 4] },
          { text: t('coupons.actions.print_code.pdf.helper2'), margin: [0, 0, 0, 4] },
          { text: t('coupons.actions.print_code.pdf.helper3'), margin: [0, 0, 0, 4] }
        ],
        margin: [8, 0, 0, 14],
        fontSize: 8
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: contentWidth,
            y2: 0,
            lineWidth: 0.8,
            lineColor: '#C7C7C7'
          }
        ]
      },
      {
        text: t('coupons.actions.print_code.pdf.customer_service'),
        margin: [70, 15, 0, 0],
        fontSize: 10
      },
      { text: coupon.hotline_number ? coupon.hotline_number : '01 70 70 46 26', margin: [70, 6, 0, 0], fontSize: 10 }
    ]
  })

  const pages = []
  let currentRows = []

  for (let i = 0; i < correlation.length; i += 3) {
    const row = []
    for (let j = 0; j < 3; j++) {
      if (i + j < correlation.length) {
        row.push({ stack: createContent(correlation[i + j]).stack, width: contentWidth })
      } else {
        row.push({ text: '', width: contentWidth })
      }
    }
    currentRows.push(row)

    if (currentRows.length === 3 || i + 3 >= correlation.length) {
      pages.push({
        table: {
          widths: [contentWidth, contentWidth, contentWidth],
          heights: [contentHeight - 8, contentHeight, contentHeight],
          body: currentRows
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineStyle: () => ({ dash: { length: 2, space: 2 } }),
          vLineStyle: () => ({ dash: { length: 2, space: 2 } }),
          hLineColor: () => 'black',
          vLineColor: () => 'black',
          paddingBottom: () => 0,
          paddingLeft: () => 0,
          paddingRight: () => 0
        },
        pageBreak: 'after'
      })
      currentRows = []
    }
  }

  if (pages.length > 0) {
    delete pages[pages.length - 1].pageBreak
  }

  return {
    content: pages,
    styles: {
      header: {
        fontSize: 14,
        margin: [0, 10, 0, 10],
        alignment: 'center'
      },
      fieldValue: {
        fontSize: 10,
        bold: true,
        alignment: 'center'
      }
    },
    pageMargins: [0, 0],
    pageSize: { width: pageWidth, height: pageHeight }
  }
}

export default generatePdfContentNotebook
